var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F5F6F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6513 12.6514C12.8141 12.4887 12.8141 12.2249 12.6513 12.0622L10.5892 10L12.6519 7.93737C12.8146 7.77465 12.8146 7.51083 12.6519 7.34811C12.4892 7.1854 12.2254 7.1854 12.0626 7.34811L9.99997 9.41079L7.93729 7.34811C7.77457 7.18539 7.51075 7.18539 7.34803 7.34811C7.18532 7.51083 7.18532 7.77465 7.34803 7.93737L9.41071 10L7.3486 12.0622C7.18588 12.2249 7.18588 12.4887 7.3486 12.6514C7.51132 12.8141 7.77514 12.8141 7.93786 12.6514L9.99997 10.5893L12.0621 12.6514C12.2248 12.8141 12.4886 12.8141 12.6513 12.6514Z",
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingCross);
export default __webpack_public_path__ + "static/media/pricing-cross.78f4f65c8423bac6e7455f98f726fd9f.svg";
export { ForwardRef as ReactComponent };